import {useId} from 'react';
import housing from '@/assets/reference-v2/armature-hd.webp';

// Generated HD material, with live date/status/actions rendered by the header.
// Viewports remove empty alpha margins without resampling the retained master.
export function ReferenceArmatureHandle(){
 return <svg className="ref-armature-handle" viewBox="1023 400 110 55" preserveAspectRatio="none" aria-hidden="true"><image href={housing} width="2172" height="724"/></svg>;
}
export default function ReferenceArmature(){
 const id=useId().replace(/:/g,'');
 return <>
  <svg className="ref-armature ref-armature-wide" viewBox="0 270 2172 184" preserveAspectRatio="none" aria-hidden="true" focusable="false">
   <defs><clipPath id={`armature-${id}`}><rect x="6" y="274" width="2160" height="172" rx="60"/><rect x="1023" y="400" width="110" height="55" rx="24"/></clipPath></defs>
   <image href={housing} width="2172" height="724" clipPath={`url(#armature-${id})`}/>
  </svg>
  <svg className="ref-armature ref-armature-compact" viewBox="1475 282 650 121" preserveAspectRatio="none" aria-hidden="true" focusable="false"><image href={housing} width="2172" height="724"/></svg>
 </>;
}
